var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.__class,style:({width:_vm.width,height:_vm.height}),attrs:{"id":_vm._comId,"src":_vm.src||_vm.finalServer+'/viewPicOriginal/'+_vm.file_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }